import { BaseApi } from "@/api/base";
import type { Response } from "@/api/client";
import type { CreateSealRequest, SealDto, UpdateSealRequest } from "@/api/trips/dto/seal.dto";

export class SealsApi extends BaseApi {
  createSeal(
    tripId: string | number,
    travelOrderId: string | number,
    data: CreateSealRequest,
  ): Promise<Response<SealDto>> {
    return this.client.post("/trips/" + tripId + "/travel-orders/" + travelOrderId + "/seals", data);
  }

  deleteSeal(
    tripId: string | number,
    travelOrderId: string | number,
    sealId: string | number,
  ): Promise<Response<void>> {
    return this.client.delete("/trips/" + tripId + "/travel-orders/" + travelOrderId + "/seals/" + sealId);
  }

  updateSeal(
    tripId: string | number,
    travelOrderId: string | number,
    sealId: string | number,
    data: UpdateSealRequest,
  ): Promise<Response<SealDto>> {
    return this.client.patch("/trips/" + tripId + "/travel-orders/" + travelOrderId + "/seals/" + sealId, data);
  }
}
